import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { sharedResourcesReducer } from '@core/shared-resources/store/shared-resources.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SharedResourcesEffects } from '@core/shared-resources/store/shared-resources.effects';
import { SharedResourcesApiService } from '@core/shared-resources/services/shared-resources-api.service';

@NgModule({
  imports: [
    StoreModule.forFeature('sharedResources', sharedResourcesReducer),
    EffectsModule.forFeature([SharedResourcesEffects]),
  ],
  declarations: [],
  providers: [SharedResourcesApiService],
})
export class SharedResourcesModule {}
